import styled, { css } from 'styled-components';

export const ShareSection = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`;

export const ShareHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 18px;
  line-height: 23px;
`;

export const ShareDescription = styled.p`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  font-size: 12px;
  line-height: 18px;
`;

export const CodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  @media(min-width: 1195px) {
    width: 30%;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
`;

export const ShareCode = styled.p`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  font-weight: 700;
  font-size: 36px;
  line-height: 1;
  color: ${({ theme }) => theme.white};
  text-transform: uppercase;
`;

export const ShareButton = styled.button`
  padding: 10px 25px;

  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: ${({ theme }) => theme.white};
  
  border: 2px solid ${({ theme }) => theme.white};
  border-radius: 50px;
  outline: none;
  
  transition: background-color 0.3s, color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.blue};
    background-color: ${({ theme }) => theme.white};
  }
`;

export const ShareTicket = styled.div`
  width: 275px;
  margin: 0 auto;
  padding: 37px 40px;
  
  background: transparent no-repeat center;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='272' height='160' fill='none' preserveAspectRatio='none'%3E%3Cpath fill='url(%23paint0_linear)' fill-rule='evenodd' d='M0 154a6 6 0 0 0 6 6h260a6 6 0 0 0 6-6V87h-.54a15 15 0 1 1 .54-30V6a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v51a15 15 0 0 1 0 30v67z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='-136' x2='3.85' y1='80' y2='317.74' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%232DB9FE'/%3E%3Cstop offset='1' stop-color='%234EDBFC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
  filter: drop-shadow(0 4px 16px rgba(30, 182, 255, 0.2));
  
  ${({ isDesktop }) => isDesktop && css`
    display: flex;
    justify-content: space-between;
    width: 690px;
    
    color: ${({ theme }) => theme.white};
    
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='688' height='160' fill='none' preserveAspectRatio='none'%3E%3Cpath fill='url(%23paint0_linear)' fill-rule='evenodd' d='M0 154a6 6 0 0 0 6 6h428.5l3.9-5.6a2 2 0 0 1 3.2 0l4 5.6H682a6 6 0 0 0 6-6V87a15 15 0 0 1 0-30V6a6 6 0 0 0-6-6H445.5l-3.9 5.6a2 2 0 0 1-3.2 0l-4-5.6H6a6 6 0 0 0-6 6v51h1a15 15 0 1 1-1 30v67z' clip-rule='evenodd'/%3E%3Cpath fill='%23FAFAFA' fill-rule='evenodd' d='M442 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2-30a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2-30a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2-30a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2-30a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='-344' x2='-273.4' y1='80' y2='383.6' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%232DB9FE'/%3E%3Cstop offset='1' stop-color='%234EDBFC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
    
    ${ShareHeading} { 
      margin-bottom: 10px;
      
      font-size: 22px;
      line-height: 28px;
    }
    
    ${ShareDescription} {
      font-size: 14px;
      line-height: 20px;
    }
  `}
`;
